const routes = {
  login: {
    root: "/login",
  },
  unauthorized: {
    unauthorized: "/unauthorized",
  },
  tenants: {
    tenants: "/tenants",
  },
  onBoarding: {
    onBoarding: "/onboarding",
  },
  createTenant:{
    createTenant: "/createTenant",
  },
  branch: {
    branch: "/branch",
  },
  schools: {
    schools: "/schools",
  },
  createSchool: {
    createSchool: "/createSchool",
  },
  schoolDetails: {
    schoolDetails: "/schoolDetails",
  },
  tenantDetails: {
    tenantDetails: "/tenantDetails",
  },
  branchDetails: {
    branchDetails: "/branchDetails",
  },
  createBranch: {
    createBranch: "/createBranch",
  },
  uploadTenants: {
    uploadTenants: "/uploadTenants",
  },
  uploadBranches: {
    uploadBranches: "/uploadBranches",
  },
};

export default routes;
